import _ from 'lodash'
import $ from 'jquery'
import BootslideMenu from 'scoreboard/components/bootslide/bootslide-menu'
import icon from 'scoreboard/components/icon'
import i18n from 'scoreboard/components/i18n'

/**
 * Returns a menu definition for setting opacity, ready to be used as a
 * bootslide menu target.
 *
 * @param {Backbone.Model} model - the model to update when the opacity is changed
 *
 * @param {Boolean} [showMaxOpacity=false] - if true, include the max (100%
 * opacity option
 *
 * @param {String} [lineColor] - the color of the line to use in the opacity
 * menu. If not provided, the 'color' property from the model will be used.
 *
 * @param {Function} [updateModel] - a function to call when the opacity is
 * changed. If not provided, the 'opacity' property from the model will be set
 *
 * @param {String} [property='opacity'] - the property on the model with the
 * opacity value
 *
 * @return {{label: String, target: {contentView: *}[]}}
 */
function opacityMenu ({ model, showMaxOpacity = false,
	lineColor, updateModel, property = 'opacity' }) {

	const opacities = getOpacities(showMaxOpacity)
	let targets = opacities.map(o => {
		let OptionClass = OpacityOption.extend({ property })
		let contentView = new OptionClass({
			opacity: o,
			lineColor,
			model,
			updateModel
		})

		return { contentView }
	})

	return {
		label: i18n.get('charts.opacity'),
		target: targets
	}
}

const OpacityOption = BootslideMenu.MultipleChoiceOption.extend({
	/** @type {ChartDesignerFeature} */
	model: null,

	property: 'opacity',

	className: BootslideMenu.MultipleChoiceOption.prototype.className + ' opacity-option',

	initialize: function (opt) {
		this.options = opt
		this.value = opt.opacity
		this.lineColor = opt.lineColor

		BootslideMenu.MultipleChoiceOption.prototype.initialize.apply(this, arguments)

		this.label = $(`<span class="checkable-content">${icon('opacity-line')}</span>`)[0]
		this.updateColor(this.getLineColor())
		this.listenTo(this.model, 'change:color', () => this.updateColor(this.getLineColor()))
	},

	getLineColor () {
		return this.lineColor ?? this.model.get('color')
	},

	updateColor(color) {
		this.$el.removeClass((index, className) => (className.match(/(^|\s)color-\S+/g) || []).join(' '))
		this.$el.addClass(`color-${color}`)
		this.$el.addClass(`color-opacity-${this.value}`)
	},

	updateModel (value) {
		if (this.options.updateModel) {
			this.options.updateModel(value)
		} else {
			BootslideMenu.MultipleChoiceOption.prototype.updateModel
				.apply(this, arguments)
		}
	}
})

/**
 * @param showMax #42595 if true, include the max opacity option
 */
function getOpacities (showMax = false) {
	// options defined in #41482
	// per #41877 100 and 5 were removed
	let values = [ 80, 65, 55, 45, 35, 25, 17, 10 ]
	if (showMax) {
		values = _.concat([ 100 ], values)
	}
	return values
}

export default opacityMenu

opacityMenu.__filename__ = 'components/bootslide/opacity-menu.js'
